<template>
  <div class="d-flex flex-column flex-column-fluid">
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            قائمة بكل الدوات الموجودة
          </h1>

        </div>
      </div>
    </div>

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isloading"
          style="font-weight: 800; border-radius: 10px; padding: 50px; font-size: large; text-align: center; background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <div v-if="!isloading" class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-4 mb-4" v-for="course in courses" :key="course.id">
            <span class="btn btn-sm btn-danger" style="padding: 5px 10px;" @click="removeCourse(course.id)">
              <i class="fa fa-trash text-white"></i>
            </span>
            <div class="card h-100">
              <div class="m-1 blog__card--thumbnail">
                <img class="rounded"
                  :src="course.preview_image ? `${courseImagePath}/${course.preview_image}` : defaultImage"
                  :alt="'Course Thumbnail'" @error="handleImageError" />
              </div>

              <div class="card-body">
                <h5 class="card-title">{{ course.title }}</h5>
                <p class="card-text">السعر: {{ course.price }} دينار</p>

              </div>
            </div>
          </div>
        </div>

        <div v-if="!isloading && courses.length != 0" class="mt-5">
          <div class="col-lg-5 col-md-5 col-sm-12 custom-bundle-order-box">
            <div class=" card shadow-lg border-0">
              <div class="card-body p-4">
                <h4 class="card-title text-center text-dark p-3 rounded" style="background-color: #ddd;">
                  <i class="fa fa-receipt text-dark"></i> تفاصيل الطلب
                </h4>

                <ul class="list-group list-group-flush mt-3">
                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span><i class="fa fa-coins text-success"></i> إجمالي السعر:</span>
                    <strong>{{ totalPrice }} دينار</strong>
                  </li>

                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span><i class="fa fa-user text-success"></i> تمت المشاركة من قبل:</span>
                    <strong>{{ user.fname }} {{ user.lname }}</strong>
                  </li>

                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span><i class="fa fa-percentage text-success"></i> نسبة التخفيض:</span>
                    <strong>{{ discountPercentage }}%</strong>
                  </li>

                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span><i class="fa fa-money-bill-wave text-success"></i> السعر النهائي :</span>
                    <strong>{{ discountedPrice.toFixed(2) }} دينار</strong>
                  </li>
                </ul>
                <!-- Confirmation Button -->
                <div class="text-center mt-4">
                  <button class="btn btn-success btn-lg" style="width:100%;background-color: #00c444;"
                    @click="openLoginModal">
                    <i class="fa fa-check-circle"></i> تأكيد الاشتراك
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <!-- Enroll Form -->
    <form id="enroll-form" @submit.prevent="handleEnroll">
      <input type="hidden" name="subcategory_id" :value="this.subcategoryId">
      <div v-for="course in courses" :key="course.id">
        <input type="hidden" :class="'course-' + course.id" :data-price="course.price"
          :data-discount="calculatedDiscount" name="courses_ids[]" :value="course.id" />
      </div>
      <input type="hidden" name="shared_by" id="shared_by" :value="sharedBy">
    </form>

    <!-- Login Modal -->
    <div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="contact__left">
              <div class="section__heading mb-50 text-center">
                <img src="/assets/img/logo-dark.png" alt="logo-img" style="width:300px;margin:0 auto" />
                <h3 class="section__heading--title mb-10">تسجيل الدخول</h3>
                <p class="section__heading--desc">
                  الرجاء إدخال بيانات حسابك في منصة أكاديميا أدناه<br />
                  ليتم إستكمال عملية الشراء
                </p>
              </div>
              <form class="contact__form" id="login-form" @submit.prevent="handleLogin">
                <div class="row">
                  <div id="validation-errors">{{ validationErrors }}</div>
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-30">
                    <label for="mobile">رقم الهاتف</label>
                    <input type="tel" v-model="mobile" class="form-control required" id="mobile" maxlength="10" />
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 mb-2">
                    <label for="password">كلمة المرور</label>
                    <input type="password" class="form-control required" v-model="password" />
                  </div>
                </div>
                <button style="width:100%;background-color: #00c444;" class="btn btn-success submit-button">
                  تسجيل الدخول <i class="bi bi-arrow-left-circle-fill"></i>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";
import '@/assets/blockui';
import Swal from "sweetalert2";
var iti;
var phone;
export default {
  name: "CustomBundleHome",
  data() {
    return {
      courses: [],
      isloading: true,
      totalPrice: 0,
      discountPercentage: 0,
      discountedPrice: 0,
      courseImagePath: baseUrl + '/images/course',
      defaultImage: "/assets/img/acad-icon.png",
      subcategoryId: null,
      mobile: '',
      password: '',
      user: {},
      validationErrors: ''
    };
  },

  mounted() {
    document.getElementById('currentYear').textContent = new Date().getFullYear();

    this.getShare();
    phone = document.querySelector("#mobile");
    $(document).ready(function () {
      iti = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly", // Set Libya as the default country
        separateDialCode: true,
        excludeCountries: ["il"],
      });
    });
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
    async getShare() {
      this.isloading = true;
      const urlParams = new URLSearchParams(window.location.search);
      const coursesParam = urlParams.get("courses") || "";
      const sbParam = urlParams.get("sb") || "0";
      try {
        const response = await fetch(
          `${apiUrl}/custom-bundles/share?courses=${coursesParam}&sb=${sbParam}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.subcategoryId = data.sub_cat.id;

          this.courses = data.courses;
          this.user = data.user;

          this.totalPrice = this.courses.reduce((sum, course) => sum + Number(course.price), 0);
          this.discountPercentage = Number(data.discount.discount);
          this.discountedPrice = this.totalPrice * (1 - this.discountPercentage / 100);
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isloading = false;
      }
    },

    removeCourse(courseId) {
      const urlParams = new URLSearchParams(window.location.search);

      // الحصول على قيمة param sb من الـ URL
      const sbParam = urlParams.get("sb") || "0";

      // الحصول على قيم الـ "courses" من الـ URL وتحويلها إلى مصفوفة
      let coursesParam = urlParams.get("courses");
      let coursesArray = coursesParam ? coursesParam.split(',') : [];

      // التحقق إذا كان هناك كورس واحد فقط
      if (coursesArray.length <= 1) {
        Swal.fire({
          icon: 'warning',
          title: 'لا يمكن حذف الكورس',
          text: 'يجب أن تحتوي الباقة على دورة واحدة على الأقل.',
          confirmButtonText: 'حسنًا'
        });
        return;
      }

      // تأكيد الحذف باستخدام Swal.fire
      Swal.fire({
        title: 'هل أنت متأكد؟',
        text: "للتأكيد اضغط نعم",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء'
      }).then((result) => {
        if (result.isConfirmed) {
          // إزالة الكورس الذي تم حذفه من المصفوفة
          coursesArray = coursesArray.filter(course => course !== courseId.toString());

          // تحويل المصفوفة بعد إزالة الكورس إلى سلسلة نصية جديدة
          const updatedCoursesParam = coursesArray.join(',');

          // إنشاء الـ URL الجديد بعد إزالة الكورس
          let redirectUrl = "/custome-bundle-share?sb=" + sbParam;

          if (updatedCoursesParam) {
            redirectUrl += "&courses=" + updatedCoursesParam;
          }

          // إعادة تحميل الصفحة بالـ URL الجديد
          window.location.href = redirectUrl;
        }
      });
    },
    openLoginModal() {
      const loginModal = new bootstrap.Modal(document.getElementById("loginModal"));
      loginModal.show();
    },

    async handleLogin() {
      try {

        $('#login-form').block({
          message: '<span style="margin:0px;padding:8px;font-size:14px;color:#29ca50;">الرجاء الإنتظار..</span>', // لون النص أخضر
          css: {
            backgroundColor: 'rgba(255, 255, 255, 0.8)', // خلفية بيضاء شفافة
            color: '#000', // لون النص الافتراضي
            border: '0px',
            padding: '15px',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: 1
          },
          overlayCSS: {
            backgroundColor: 'rgb(204 204 204 / 80%)', // تغيير لون الخلفية overlay إلى أبيض شفاف
            opacity: 0.8, // يمكنك ضبط الشفافية هنا
            cursor: 'wait'
          }
        });
        const formData = new FormData();
        formData.append('mobile', iti.getNumber());
        formData.append('password', this.password);

        const response = await fetch(`${apiUrl}/loginWithoutChecks`, {
          method: 'POST',

          body: formData
        });

        if (response.ok) {
          const data = await response.json();
          this.handleEnroll(data.access_token);
        } else {
          const errorData = await response.json();
          this.validationErrors = errorData.message || "خطأ في تسجيل الدخول";
        }
      } catch (error) {
        console.error("Login error:", error);
      }
    },


    async handleEnroll(token) {
      const form = document.getElementById("enroll-form");
      const formData = new FormData(form);

      try {
        const response = await fetch(`${apiUrl}/custom-bundles/enroll`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });

        if (response.ok) {
          Swal.fire({
            title: "تم الاشتراك بنجاح",
            text: "نتمنى لك التوفيق",
            icon: 'success',
            confirmButtonText: 'موافق'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/home"; // الانتقال إلى صفحة الرئيسية
            }
          });
        } else {
          const errorData = await response.json();
          Swal.fire({
            title: 'حدثت مشكلة',
            text: errorData.message,
            icon: 'error',
            confirmButtonText: 'موافق'
          });
          $('#login-form').unblock();
        }
      } catch (error) {
        console.error("Enrollment error:", error);
        alert("حدث خطأ أثناء الاشتراك");
      }
    }
  }
};
</script>

<style scoped>
/* يمكنك إضافة التنسيقات المخصصة هنا */
</style>
